"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = isNullOrUndefined;
/**
 * Often, we mistakenly use !value to verify the existence of a value.
 * However, this approach fails when the value is e.g. 0 or ''.
 * This helper is designed to avoid that pitfall.
 * @param value The value
 * @returns True if the value is null or undefined, otherwise false
 */
function isNullOrUndefined(value) {
    /**
     * We use == intentionally here as it works with both 'null' and 'undefined'
     * eslint rule eqeqeq will eventually be enforced and will need to be disabled here rather than fixed.
     */
    return value == null;
}
//# sourceMappingURL=NullOrUndefinedHelper.js.map